(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  if (!global.NewHomeSource.Helpers ||
    !global.NewHomeSource.Helpers.Array) {
    return;
  }

  const arrayHelper = global.NewHomeSource.Helpers.Array;

  class SlideSizes {
    /**
     * Initializes a new instance of the class.
     * Sets the initial state to null.
     */
    constructor() {
      this.state = null;
    }

    /**
     * Initializes the object with the provided state.
     *
     * @param {Object} state - The state object to initialize with.
     */
    initialize(state) {
      this.state = state;
      return this;
    }

    /**
     * Measures the gap between the start edge of the container and the start edge of the first slide.
     *
     * @returns {number} The absolute distance (in pixels) between the container's start edge and the first slide's
     * start edge.
     */
    measureEdgeGap() {
      const axis = this.state.get('axis');
      const containerRect = this.state.get('containerRect');
      const slideRects = this.state.get('slideRects');
      const startEdge = axis.getStartEdge();
      const slideRect = slideRects[0];
      return Math.abs(containerRect[startEdge] - slideRect[startEdge]);
    }

    /**
     * Measures the gap between the first two slides in the carousel.
     *
     * Retrieves the bounding rectangles of the slides and calculates the absolute
     * distance between the end edge of the first slide and the start edge of the second slide
     * along the specified axis. If there are fewer than two slides, returns 0.
     *
     * @returns {number} The absolute gap in pixels between the first two slides, or 0 if not applicable.
     */
    measureSliceGap() {
      const slideRects = this.state.get('slideRects');
      if (slideRects.length < 2) {
        return 0;
      }

      const axis = this.state.get('axis');
      const startEdge = axis.getStartEdge();
      const endEdge = axis.getEndEdge();
      const firstSlide = slideRects[0];
      const secondSlide = slideRects[1];
      return Math.abs(secondSlide[startEdge] - firstSlide[endEdge]);
    }

    /**
     * Measures the sizes of slides including the gaps between them.
     *
     * For each slide, calculates its size by considering the gap after the slide.
     * For the first and last slides, adds the gap to the measured size.
     * For other slides, computes the size as the distance between the start edges of consecutive slides.
     *
     * @returns {number[]} An array of absolute sizes for each slide, including gaps.
     */
    measureWithGaps() {
      const slideRects = this.state.get('slideRects');
      const axis = this.state.get('axis');
      const loop = this.state.get('loop');
      const startEdge = axis.getStartEdge();
      const slideSizes = this.measureWithoutGaps();
      const edgeGap = this.measureEdgeGap();
      const sliceGap = loop ? this.measureSliceGap() : 0;

      return slideRects.map((rect, index, rects) => {
        const isEdge = !index || arrayHelper.arrayLastIndex(rects) === index;
        if (isEdge) {
          const edgeSize = slideSizes[index] + edgeGap + sliceGap;
          return Math.abs(edgeSize);
        }

        const size = rects[index + 1][startEdge] - rect[startEdge];
        return Math.abs(size);
      });
    }

    /**
     * Measures the sizes of all slides without accounting for gaps between them.
     *
     * Retrieves the bounding rectangles of each slide from the state and uses the current axis
     * to measure the size (width or height) of each rectangle.
     *
     * @returns {number[]} An array of sizes for each slide, measured along the current axis.
     */
    measureWithoutGaps() {
      const slideRects = this.state.get('slideRects');
      const axis = this.state.get('axis');
      return slideRects.map((rect) => axis.measureSize(rect));
    }
  }

  global.NewHomeSource.Carousel.SlideSizes = SlideSizes;
}(window));
